import { useTranslation } from "react-i18next";
import { SignaturePad } from "./SignaturePad";
import "./confirm.css";

// ترويسة سوداء ممتدة + بيانات الشركة بالذهبي + شبكة المعلومات 2×2.
export const ConfirmHeader = ({ company, order }) => {
  const { t } = useTranslation();
  const rows = [["number", order.number], ["date", order.date],
                ["supplier", order.supplier_ar || order.supplier],
                ["state", t(`purchases.states.${order.state}`, order.state)]];

  return (
    <section className="pc-card" data-testid="confirm-header">
      <div className="pc-head">
        <p style={{ fontSize: 17, fontWeight: 800 }}>
          📋 {t("purchases.print.title")} — <span className="pc-num">{order.number}</span>
        </p>
      </div>
      <div className="pc-company">
        {company?.logo_url ? <img src={company.logo_url} alt="" /> : null}
        <b>{company?.name}</b>
        <span className="pc-num" style={{ fontSize: 11, color: "#6b7280" }}>#{company?.serial}</span>
      </div>
      <div className="pc-grid">
        {rows.map(([key, value]) => (
          <div key={key}>
            <b>{t(`purchases.print.${key}`)}</b>
            <span className="pc-num">{value || "—"}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

// إيصال ما بعد التأكيد: ترويسة خضراء + شريط المؤكِّد + التوقيع + طباعة المستند الرسمي.
export const ConfirmReceipt = ({ name, at, signature, total, currency, token }) => {
  const { t } = useTranslation();
  const printUrl = `${process.env.REACT_APP_BACKEND_URL}/api/purchase-confirm/${token}/print`;
  return (
    <section className="pc-card" data-testid="confirm-receipt">
      <div className="pc-head pc-head-ok">
        <p style={{ fontSize: 17, fontWeight: 800 }}>✅ {t("purchases.confirm.thanks")}</p>
      </div>
      <p className="pc-badge">
        {t("purchases.confirm.confirmedBy")}: {name || "—"} | <span className="pc-num">{(at || "").slice(0, 10)}</span>
      </p>
      <div className="pc-total">
        <span>{t("purchases.print.grandTotal")}</span>
        <span className="pc-num">{total} {currency}</span>
      </div>
      {signature ? (
        <div className="pc-signbox"><img src={signature} alt="signature" /></div>
      ) : null}
      <div className="pc-noprint" style={{ textAlign: "center", padding: 14 }}>
        <a href={printUrl} target="_blank" rel="noreferrer" className="pc-print"
           data-testid="confirm-print" style={{ textDecoration: "none", display: "inline-block" }}>
          🖨️ {t("purchases.confirm.print")}
        </a>
      </div>
    </section>
  );
};

// نموذج التأكيد بخلفية تحذيرية: اسم المستلم + ملاحظات + توقيع + موافقة.
export const ConfirmForm = ({ form, setForm, busy, onSubmit }) => {
  const { t } = useTranslation();
  const ready = form.name.trim().length >= 2 && form.signature && form.agreed;

  return (
    <section className="pc-confirm pc-noprint" data-testid="confirm-form">
      <p style={{ fontWeight: 800, color: "#92400e" }}>{t("purchases.confirm.title")}</p>
      <input className="pc-input" data-testid="confirm-name" placeholder={t("purchases.confirm.name")}
             value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
      <input className="pc-input" data-testid="confirm-notes" placeholder={t("purchases.confirm.notes")}
             value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
      <SignaturePad onChange={(signature) => setForm((prev) => ({ ...prev, signature }))} />
      <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, fontWeight: 700 }}>
        <input type="checkbox" data-testid="confirm-agree" checked={form.agreed}
               onChange={(e) => setForm({ ...form, agreed: e.target.checked })} />
        {t("purchases.confirm.agree")}
      </label>
      <button type="button" className="pc-submit" data-testid="confirm-submit"
              disabled={busy || !ready} onClick={onSubmit}>
        {t("purchases.confirm.submit")}
      </button>
    </section>
  );
};
